import React from 'react';
import { Menu, MenuOpen } from '@material-ui/icons';
import { isMobile } from 'react-device-detect';
import PropTypes from 'prop-types';
import styles from 'styles/components/mobileMenuHandler.module.scss';

export default function MobileMenuHandler(props) {
    const { isMobileMenuOpen, setIsMobileMenuOpen } = props;
    return (
        <div className={styles.root}>
            {isMobile && !isMobileMenuOpen ? (
                <Menu
                    onClick={() => setIsMobileMenuOpen(true)}
                    className={styles.menuIcon}
                />
            ) : null}
            {isMobile && isMobileMenuOpen ? (
                <MenuOpen
                    onClick={() => setIsMobileMenuOpen(false)}
                    className={styles.menuIcon}
                />
            ) : null}
        </div>
    );
}

MobileMenuHandler.propTypes = {
    isMobileMenuOpen: PropTypes.bool.isRequired,
    setIsMobileMenuOpen: PropTypes.func.isRequired,
};
